import React, { useEffect, useState } from "react";
import { Alert, AlertTitle, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import usePrivilegeCheck from "../../../constants/customHooks/UsePrivilegeCheck";
import DownloadExcel from "../../extraComponents/DownloadExcel";
import DownloadPdf from "../../extraComponents/DownloadPdf";
import ApprovalSearchHeader from "./ApprovalSearchHeader";
import ApprovalFilterSearch from "./ApprovalFilterSearch";
import { tutionFeepaymentApprovalFindAction } from "../../../actions/paymentApprovalAction";
import TutionFeeApprovalTable from "./tutionFeeApprovalTable";

function TutionFeeApprovalMain(props) {
  const dispatch = useDispatch();
  const [filterPassData, setFilterPassData] = useState();
  const [whichFilter, setwhichFilter] = useState();
  const [reset, setReset] = useState(false);
  const [leadData, setLeadData] = useState([]);
  const [paymentApprovallist, setPaymentApprovalList] = useState([]);

  const { privilege, hasPrivilege } = usePrivilegeCheck();

  // Employee column Visibility

  const [showNameColumn, setshowNameColumn] = useState(false);
  const [showDateColumn, setshowDateColumn] = useState(false);
  const [showMailIdColumn, setshowMailIdColumn] = useState(false);
  const [showPhoneNumberColumn, setshowPhoneNumberColumn] = useState(false);
  const [showCountryOfResidenceColumn, setShowCountryResidenceColumn] =
    useState(false);
  const [showReferredByColumn, setshowReferredByColumn] = useState(false);
  const [showStatusColumn, setShowStatusColumn] = useState(false);

  const [columnName, setColumnName] = useState("");
  const [leadId, setLeadId] = useState([]);
  const [ids, setIds] = useState([]);

  // tabel columns

  const columns = [
    {
      title: "SL NO",
      field: "sl"
    },
    {
      title: "STUDENT ID",
      field: "STUDENT ID",
      hidden: showNameColumn
    },
    {
      title: "STUDENT NAME",
      field: "STUDENT NAME",
      hidden: showDateColumn
    },

    {
      title: "PASSPORT NUMBER",
      field: "PASSPORT NUMBER",
      hidden: showNameColumn,
    },
    {
      title: "EMAIL",
      field: "EMAIL",
      hidden: showNameColumn,
    },
    {
      title: "PHONE NUMBER",
      field: "PHONE NUMBER",
      hidden: showNameColumn,
    },
    {
      title: "APPLICATION ID",
      field: "APPLICATION ID",
      hidden: showDateColumn
    },
    {
      title: "COUNTRY",
      field: "COUNTRY",
      hidden: showMailIdColumn
    },
    {
      title: "UNIVERSITY",
      field: "UNIVERSITY",
      hidden: showPhoneNumberColumn
    },
    {
      title: "UNIVERSITY TYPE",
      field: "UNIVERSITY TYPE",
      hidden: showCountryOfResidenceColumn
    },
    {
      title: "COURSE",
      field: "COURSE",
      hidden: showReferredByColumn
    },
    {
      title: "TOTAL AMOUNT",
      field: "TOTAL AMOUNT",
      hidden: showStatusColumn
    },

    {
      title: "SCHOLERSHIP",
      field: "SCHOLERSHIP",
      hidden: showStatusColumn
    },
    {
      title: "DISCOUNT",
      field: "DISCOUNT",
      hidden: showStatusColumn
    },
    {
      title: "PAID AMOUNT",
      field: "PAID AMOUNT",
      hidden: showStatusColumn
    },
    {
      title: "TOTAL PAID AMOUNT",
      field: "TOTAL PAID AMOUNT",
      hidden: showStatusColumn
    },

    {
      title: "BALANCE AMOUNT",
      field: "BALANCE AMOUNT",
      hidden: showStatusColumn
    },
    {
      title: "PAYMENT UPDATED BY",
      field: "PAYMENT UPDATED BY",
      hidden: showStatusColumn
    },
    {
      title: "PAID DATE &TIME",
      field: "PAID DATE &TIME",
      hidden: showStatusColumn
    },
    {
      title: "REMARK",
      field: "REMARK",
      hidden: showStatusColumn
    },
    {
      title: "STATUS",
      field: "STATUS",
      hidden: showStatusColumn
    },

    {
      title: "RECEIPT",
      field: "RECEIPT",
      hidden: showStatusColumn
    },
    {
      title: "ACTION",
      field: "ACTION",
      hidden: showStatusColumn
    }
  ];

  let { tutionFeePaymentApprovalFindSuccess, tutionFeePaymentApprovalFindErr } =
    useSelector((state) => {
      return state.tutionFeePaymentApprovalFind;
    });    
      
  const { tutionFeePaymentApprovalSuccess } = useSelector((state) => state.tutionFeePaymentReject)

  let {
    tutionFeePaymentApprovalApproveSuccess,
    tutionFeePaymentApprovalApproveErr
  } = useSelector((state) => {
    return state.tutionFeePaymentApprovalApprove;
  });

  useEffect(() => {
    dispatch(tutionFeepaymentApprovalFindAction());
  }, [dispatch, tutionFeePaymentApprovalApproveSuccess, tutionFeePaymentApprovalSuccess]);
  
  useEffect(() => {
    if (tutionFeePaymentApprovalFindSuccess) {
      setPaymentApprovalList(tutionFeePaymentApprovalFindSuccess.data);
    }
  }, [tutionFeePaymentApprovalFindSuccess, reset]);

  // Handle SearchFunction

  const searchHandleChange = (value) => {
    if (value) {
      setPaymentApprovalList(
        tutionFeePaymentApprovalFindSuccess.data?.filter((item) => {
          const valueLower = value?.toLowerCase() || "";

          const countryMatch = item.lead_applied_short_list.universityCountry
            ? item.lead_applied_short_list.universityCountry
                .toLowerCase()
                .includes(valueLower)
            : false;

          const nameMatch = item.lead?.firstName
            ? item.lead.firstName.toLowerCase().includes(valueLower)
            : false;

          const studentIdMatch = item.lead_applied_short_list?.universityGivenId
            ? item.lead_applied_short_list.universityGivenId
                .toLowerCase()
                .includes(valueLower)
            : false;

          const universityMatch = item.lead_applied_short_list?.universityName
            ? item.lead_applied_short_list.universityName
                .toLowerCase()
                .includes(valueLower)
            : false;

          const courseMatch = item.lead_applied_short_list?.courseName
            ? item.lead_applied_short_list?.courseName
                .toLowerCase()
                .includes(valueLower)
            : false;

          const statusMatch = item?.paymentStatus
            ? item?.paymentStatus.toLowerCase().includes(valueLower)
            : false;

          const applicationId = item?.lead_applied_short_list?.applicationId
            ? item?.lead_applied_short_list?.applicationId
                .toLowerCase()
                .includes(valueLower)
            : false;

          const universityType = item?.lead_applied_short_list?.university
            ?.universityType
            ? item?.lead_applied_short_list?.university?.universityType
                .toLowerCase()
                .includes(valueLower)
            : false;

          return (
            countryMatch ||
            nameMatch ||
            studentIdMatch ||
            universityMatch ||
            courseMatch ||
            statusMatch ||
            applicationId ||
            universityType
          );
        })
      );
    } else {
      setPaymentApprovalList(tutionFeePaymentApprovalFindSuccess.data);
    }
  };

  const setIdsFunction = (leadsId) => {
    setLeadId(leadsId);
  };

  const selectBoxIdPassHandler = (ids) => {
    setIds(ids);
  };

  if (!hasPrivilege("TutionFee Approval") && privilege !== null) {
    return (
      <Alert severity="error">
        <AlertTitle>warning</AlertTitle>
        You don't have permission to access — <strong>this page.!</strong>
      </Alert>
    );
  }

  // // handleFilter Data

  const LeadFilterFunction = (data, filterOption, checkedStatus) => {
    if (filterOption === "status") {
      if (checkedStatus === true) {
        const filterData = tutionFeePaymentApprovalFindSuccess.data?.filter(
          (value) => data == value.status
        );
        setPaymentApprovalList(filterData);
        setwhichFilter(filterOption);
        setFilterPassData(data);
      } else {
        setwhichFilter(null);
        setFilterPassData(null);
        setPaymentApprovalList(tutionFeePaymentApprovalFindSuccess.data);
      }
    }
    if (filterOption === "Date") {
      const date = new Date(data);
      const adjustedDate = new Date(
        date.getTime() - date.getTimezoneOffset() * 60000
      );
      const formattedDate = adjustedDate.toISOString().split("T")[0];

      const filterData = tutionFeePaymentApprovalFindSuccess.data?.filter(
        (value) => formattedDate == value.createdAt.split("T")[0]
      );

      console.log(filterData, "filterDataaaa");
      setPaymentApprovalList(filterData);
      // setwhichFilter(filterOption);
      // setFilterPassData("");
    }

    if (filterOption == "course") {
      if (checkedStatus === true) {
        const filterData = tutionFeePaymentApprovalFindSuccess.data?.filter(
          (value) =>
            value.lead_applied_short_list?.courseName
              .toLowerCase()
              .includes(data.toLowerCase())
        );
        setPaymentApprovalList(filterData);
        setwhichFilter(filterOption);
        setFilterPassData(data);
      } else {
        setwhichFilter(null);
        setFilterPassData(null);
        setPaymentApprovalList(tutionFeePaymentApprovalFindSuccess.data);
      }
    }

    if (filterOption == "university") {
      if (checkedStatus === true) {
        const filterData = tutionFeePaymentApprovalFindSuccess.data?.filter(
          (value) =>
            value.lead_applied_short_list?.universityName
              .toLowerCase()
              .includes(data.toLowerCase())
        );
        setPaymentApprovalList(filterData);
        setwhichFilter(filterOption);
        setFilterPassData(data);
      } else {
        setwhichFilter(null);
        setFilterPassData(null);
        setPaymentApprovalList(tutionFeePaymentApprovalFindSuccess.data);
      }
    }

    if (filterOption == "Country") {
      if (checkedStatus === true) {
        const filterData = tutionFeePaymentApprovalFindSuccess.data?.filter(
          (value) =>
            value.lead_applied_short_list?.universityCountry
              .toLowerCase()
              .includes(data.toLowerCase())
        );
        setPaymentApprovalList(filterData);
        setwhichFilter(filterOption);
        setFilterPassData(data);
      } else {
        setwhichFilter(null);
        setFilterPassData(null);
        setPaymentApprovalList(tutionFeePaymentApprovalFindSuccess.data);
      }
    }

    if (filterOption == "paymentType") {
      if (checkedStatus === true) {
        console.log(data, "datadatadatadatadatadata");
        const filterData = tutionFeePaymentApprovalFindSuccess.data?.filter(
          (value) => value.paymentStatus?.toLowerCase() == data?.toLowerCase()
        );
        setPaymentApprovalList(filterData);
        setwhichFilter(filterOption);
        setFilterPassData(data);
      } else {
        setwhichFilter(null);
        setFilterPassData(null);
        setPaymentApprovalList(tutionFeePaymentApprovalFindSuccess.data);
      }
    }

    if (filterOption == "universityType") {
      console.log(data, "vissssssssssssss");
      if (checkedStatus === true) {
        const filterData = tutionFeePaymentApprovalFindSuccess.data?.filter(
          (value) =>
            value.lead_applied_short_list?.university?.universityType?.toLowerCase() ==
            data?.toLowerCase()
        );

        console.log(filterData, "filterrrrrrrrrrrrr");
        setPaymentApprovalList(filterData);
        setwhichFilter(filterOption);
        setFilterPassData(data);
      } else {
        setwhichFilter(null);
        setFilterPassData(null);
        setPaymentApprovalList(tutionFeePaymentApprovalFindSuccess.data);
      }
    }

    if (filterOption == "paymentDate") {
      const paymentDateBtw = checkedStatus?.map((value) => value?.$d);
      const dateObject1 = new Date(paymentDateBtw[0]);
      const dateObject2 = new Date(paymentDateBtw[1]);
      const options = { year: "numeric", month: "long", day: "numeric" };
      const formattedDate1 = new Intl.DateTimeFormat("en-US", options).format(
        dateObject1
      );
      const formattedDate2 = new Intl.DateTimeFormat("en-US", options).format(
        dateObject2
      );
      const finalFormattedDate1 = formattedDate1.replace(",", "");
      const finalFormattedDate2 = formattedDate2.replace(",", "");

      // Convert formatted dates back to Date objects
      const date1 = new Date(finalFormattedDate1);
      const date2 = new Date(finalFormattedDate2);

      console.log(date1, date2, "date2date2date2date2");
      const filterData = tutionFeePaymentApprovalFindSuccess.data?.filter(
        (value) => {
          // Parse the paymentUpdatedDate
          const paymentDateString = value.paidDate; // e.g., "October 3 2024"
          const paymentDate = new Date(paymentDateString); // Convert to Date object
          console.log(paymentDate, "paymentDateStringpaymentDateString");
          // Check if paymentDate is between date1 and date2
          return paymentDate >= date1 && paymentDate <= date2;
        }
      );
      setPaymentApprovalList(filterData);
      setwhichFilter(filterOption);
      setFilterPassData(data);
    }
  };

  // handleResetData

  const handleResetData = (status) => {
    setwhichFilter(null);
    setFilterPassData(null);
    setReset(!reset);
    setwhichFilter(null);
    setFilterPassData(null);
  };

  console.log(
    tutionFeePaymentApprovalFindSuccess,
    "tutionFeePaymentApprovalFindSuccessdatatutionFeePaymentApprovalFindSuccess"
  );

  return (
    <>
      <ApprovalSearchHeader
        // columnVisibleHandler={toggleNameColumn}
        // excelDownloadClick={excelDownloadClick}
        // pdfDownloadClick={pdfDownloadClick}
        showNameColumnColumn={showNameColumn}
        showDateColumn={showDateColumn}
        showPhoneNumberColumn={showPhoneNumberColumn}
        showMailIdColumn={showMailIdColumn}
        showCountryOfResidenceColumn={showCountryOfResidenceColumn}
        showReferredByColumn={showReferredByColumn}
        showStatusColumn={showStatusColumn}
        handleResetData={handleResetData}
        searchHandleChange={searchHandleChange}
        ids={ids}
        leadId={leadId}
      />
      {/* <div style={{display:"flex",justifyContent:"space-evenly", width:"auto"}}> */}
      <Grid container spacing={-3} sx={{ mt: "-31px" }}>
        <Grid item xs={12} md={2} lg={2.2}>
          <ApprovalFilterSearch
            LeadFilterFunction={LeadFilterFunction}
            handleResetData={handleResetData}
            component="tutionFeeApproval"
            data={paymentApprovallist}
          />
        </Grid>
        <Grid item xs={12} md={10} lg={9.8}>
          <TutionFeeApprovalTable
            toggle={props.toggle}
            showNameColumnColumn={showNameColumn}
            showDateColumn={showDateColumn}
            showPhoneNumberColumn={showPhoneNumberColumn}
            showMailIdColumn={showMailIdColumn}
            showCountryOfResidenceColumn={showCountryOfResidenceColumn}
            showReferredByColumn={showReferredByColumn}
            showStatusColumn={showStatusColumn}
            reset={reset}
            setIdsFunction={setIdsFunction}
            data={paymentApprovallist}
            // leadFindLoading={leadFindLoading}
            selectBoxIdPassHandler={selectBoxIdPassHandler}
            // isExistCounsilor={loginFindSuccess}
            component="EmployeeJob"
            columns={columns}
            subMenu="TutionFee Approval"
          />
        </Grid>
      </Grid>
    </>
  );
}

export default TutionFeeApprovalMain;
